import { Box } from "@mui/material";
import { MarkdownMessage as ReviewMarkdownMessage } from "@/features/board/review/MarkdownMessage";

export const MarkdownMessage = ({ content }: { content: string }) => (
  <Box
    data-chat-markdown="coaching"
    sx={{
      "& [data-chat-prose]": { fontSize: ".84rem", lineHeight: 1.7, overflowWrap: "anywhere" },
      "& [data-chat-prose] p": { my: 1 },
      "& [data-chat-prose] h1, & [data-chat-prose] h2, & [data-chat-prose] h3": {
        mt: 2.1,
        mb: 0.8,
        color: "text.primary",
        lineHeight: 1.25,
      },
      "& [data-chat-prose] a": {
        color: "primary.light",
        textDecoration: "underline",
        textDecorationThickness: "1px",
        textUnderlineOffset: "3px",
        "&:hover, &:focus-visible": { color: "primary.main", textDecorationThickness: "2px" },
      },
      "& [data-chat-prose] ul": { pl: 2.35, listStyle: "disc" },
      "& [data-chat-prose] ol": { pl: 3, listStyle: "decimal" },
      "& [data-chat-prose] li": {
        py: 0.45,
        pl: 0.2,
        borderInlineStart: 0,
        bgcolor: "transparent",
      },
      "& [data-chat-prose] li::before": { display: "none" },
      "& [data-chat-prose] li::marker": { color: "text.secondary", fontWeight: 800 },
      "& [data-chat-prose] blockquote": {
        borderColor: "rgba(240,236,226,.3)",
        bgcolor: "rgba(240,236,226,.035)",
        px: 1.5,
        py: 0.25,
        color: "text.secondary",
      },
      "& [data-chat-prose] :not(pre) > code": {
        px: 0.45,
        py: 0.15,
        bgcolor: "rgba(240,236,226,.1)",
        fontSize: ".9em",
      },
      "& [data-chat-prose] pre": { overflowX: "auto", scrollbarGutter: "stable", my: 1.25 },
      "& [data-chat-prose] table": { width: "100%", borderCollapse: "collapse", fontSize: ".78rem" },
      "& [data-chat-prose] th, & [data-chat-prose] td": {
        px: 1,
        py: 0.7,
        borderBottom: "1px solid",
        borderColor: "divider",
        textAlign: "start",
      },
      "& [data-chat-prose] th": { color: "text.primary", fontWeight: 850 },
    }}
  >
    <ReviewMarkdownMessage content={content} />
  </Box>
);
